module.exports = __webpack_public_path__ + "img/lema-logo-white.10c5ceab.svg";